import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { getFlatTourBookingSchedule } from '../../selectors/newbuildingFlatTourBooking';

interface INewbuildingFlatTourBookingModalContainerProps {
  newbuildingName: string;
  isOpen: boolean;
  onSubmit(params: ICallbackParams): Promise<boolean>;
  onSuccess(params: ICallbackParams): void;
  onClose(): void;
}

const NewbuildingFlatTourBookingModalContainer: React.FC<INewbuildingFlatTourBookingModalContainerProps> = ({
  newbuildingName,
  isOpen,
  onClose,
  onSuccess,
  onSubmit,
}) => {
  const schedule = useSelector(getFlatTourBookingSchedule);

  if (!schedule) {
    return null;
  }

  return (
    <FlatViewOrderSinglePageDesktop
      isOpen={isOpen}
      onSubmit={onSubmit}
      onSuccess={onSuccess}
      onClose={onClose}
      disabledDays={schedule.disabledDays}
      availableDates={schedule.availableDates}
      newbuildingName={newbuildingName}
      minDate={schedule.minDate}
      maxDate={schedule.maxDate}
      nextDate={schedule.nextDate}
      nextNextDate={schedule.nextNextDate}
    />
  );
};

// eslint-disable-next-line import/no-default-export
export default NewbuildingFlatTourBookingModalContainer;
